<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>商品评价详情</b>
    </a-divider>
    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="商品信息"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">商品编号：</td>
                  <td class="data" colspan="7">
                    {{ this.form.goodsId}}
                  </td>
                </tr>
                <tr>
                  <td class="first">商品名称：</td>
                  <td class="data"  colspan="7">
                    {{this.form.goodsName}}
                  </td>
                </tr>
                <tr>
                  <td class="first">商品价格：</td>
                  <td class="data">
                    {{ this.form.price}}
                  </td>
                  <td class="first">商品图片：</td>
                  <td class="data">
                    <img :src="this.form.picture" style="width: 100px;height: 100px;" @click="handleRecordPreview(form.picture)">
                  </td>
                </tr>
                <tr>
                  <td class="first">商家名称：</td>
                  <td class="data">
                    {{ this.form.merchantName}}
                  </td>
                  <td class="first">商家logo：</td>
                  <td class="data">
                    <img :src="this.form.merchantLogo" style="width: 100px;height: 100px;" @click="handleRecordPreview(form.merchantLogo)">
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="评价信息"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">评价人：</td>
                  <td class="data">
                    {{ this.form.userName}}
                  </td>
                  <td class="first">是否匿名：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.TFEnum" :value="form.isAnonymous"/>
                  </td>
                </tr>
                <tr>
                  <td class="first">评价时间：</td>
                  <td class="data">
                    {{ this.form.createTime}}
                  </td>
                </tr>
                <tr>
                  <td class="first">评价星级：</td>
                  <a-rate v-model="form.evaluateScore" :disabled="true" />
                </tr>
                <tr>
                  <td class="first">评价内容：</td>
                  <td class="data">{{ this.form.content}}</td>
                </tr>
                <tr>
                  <td class="first">评价图片：</td>
                  <td class="data"  v-if="form.imageList">
                    <template v-for="(img, index) in form.imageList">
                      <img v-if="img" :src="img"  style="width:60px;height:62px;" @click="handleRecordPreview(img)" alt="none"/>
                    </template>
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>

        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="回复信息"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <a slot="extra">
              </a>
              <a-input v-model="form.explainFirst" type="textarea" :placeholder="this.$t('请输入')+this.$t('回复内容')"></a-input>
            </a-card>
          </td>
        </tr>
      </table>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary" @click="submitForm">
          回复
        </a-button>
        <a-button type="dashed" @click="cancel">
          {{$t('关闭')}}
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getGoodsEvaluate, addGoodsEvaluate, replayGoodsEvaluate } from '@/api/goods/goodsEvaluate'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 表单参数
      form: {
        id: null,

        orderId: null,

        goodsId: null,

        merchantId: null,

        deptId: null,

        content: null,

        imageList: null,

        explainFirst: null,

        starNum: null,

        userId: null,

        userName: null,

        avatar: null,

        isAnonymous: null,

        evaluateScore: null,

        qualityScore: null,

        serviceScore: null,

        againContent: null,

        againImage: null,

        againAddTime: null,

        againExplain: null,

        explainType: null,

        isShow: null,

        pushTop: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        orderId: [
          { required: true, message: '订单ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        goodsId: [
          { required: true, message: '商品ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantId: [
          { required: true, message: '商家ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        deptId: [
          { required: true, message: '部门ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: '评价内容'+this.$t('不能为空'), trigger: 'blur' }
        ],
        image: [
          { required: true, message: '评价图片'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '评价人userId'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '评价人名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        isAnonymous: [
          { required: true, message: '0表示不是 1表示是匿名评价'+this.$t('不能为空'), trigger: 'blur' }
        ],
        evaluateScore: [
          { required: true, message: '评价星级'+this.$t('不能为空'), trigger: 'blur' }
        ],
        qualityScore: [
          { required: true, message: '物流服务'+this.$t('不能为空'), trigger: 'blur' }
        ],
        serviceScore: [
          { required: true, message: '服务评分'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        orderId: null,
        goodsId: null,
        merchantId: null,
        deptId: null,
        content: null,
        imageList: null,
        explainFirst: null,
        starNum: null,
        userId: null,
        userName: null,
        avatar: null,
        isAnonymous: null,
        evaluateScore: null,
        qualityScore: null,
        serviceScore: null,
        againContent: null,
        againImage: null,
        againAddTime: null,
        againExplain: null,
        explainType: null,
        isShow: null,
        pushTop: null,
        createTime: null,
        remark: null
      }

    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },

    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoodsEvaluate({"id":id}).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.submitLoading = true
      let replay = {"id": this.form.id, "explainFirst": this.form.explainFirst}
      let message = '';
      if (this.form.id !== undefined && this.form.id !== null) {
        message = this.$t('修改成功')
        replayGoodsEvaluate(replay).then(response => {
          this.$message.success(
            message,
            3
          )
          this.open = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.message-text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}

.fontblack {
  color: #999999
}

.img2 {
  width: .81rem;
  height: .8rem;
  float: right;
}


.orderTitle {
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}

.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}

.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}

.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}

ul li {
  list-style: none;
  font-size: 1rem;
}

ul {
  padding-left: 1.5rem
}

.track-rcol {
}

.track-list {
  position: relative;
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}

.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}

.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}

.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}

.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}

.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}

.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}

.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}

.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 120px;
    }

    .data {
      width: 300px;
    }
  }
}

.detailPanel {
  dd, dt {
    display: inline-block;
    vertical-align: center;
  }

  dt img {
    margin: 0 20px 5px 0px;
  }

  dd {
    h3 {
      font-weight: bold;
    }
  }

  .trade-detail-prompt {
    margin-left: 35px;

    li {
      font-size: 13px !important;

      .dotted-node {
        padding: 0 5px;
      }
    }
  }
}

.order-money {
  .om-c1 {
    font-size: 14px;
    color: #666
  }

  .om-c2 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .om-c3 {
    font-size: 16px;
    color: #DE3636;
    font-weight: bold;
  }

  td {
    text-align: right;
  }

  float: right;
  margin: 20px 40px 20px 0;
}
</style>
